import { render, staticRenderFns } from "./customerConfig.vue?vue&type=template&id=58710c8f&scoped=true"
import script from "./customerConfig.vue?vue&type=script&lang=js"
export * from "./customerConfig.vue?vue&type=script&lang=js"
import style0 from "./customerConfig.vue?vue&type=style&index=0&id=58710c8f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58710c8f",
  null
  
)

export default component.exports